import { defaultPagination } from "app/redux/initialState";
import {
  ITimeSheetTicketList,
  ITimeTrackerForm,
  TimeSheetState,
} from "../types";

export const defaultTimeTrackerForm: ITimeTrackerForm = {
  selectedTicketDetails: {
    _id: "",
    ticketName: "",
    projectId: "",
  },
  date: new Date().toISOString(),
  startTime: new Date().toISOString(),
  endTime: new Date().toISOString(),
  hours: 0,
  minutes: 0,
};

export const timeSheetTicketListInitialState: ITimeSheetTicketList = {
  data: [],
  loading: false,
  moreLoading: false,
  pagination: defaultPagination,
};

export const timeSheetInitialState: TimeSheetState = {
  timeSheet: {
    loading: false,
    loadingMore: false,
    data: [],
    pagination: defaultPagination,
  },
  timeSheetEntryDeleteLoading: false,
  timeTrackerForm: defaultTimeTrackerForm,
  effortActualRequestLoading: false,
  enableTimeTrackerPreview: false,
  activeTimerForm: defaultTimeTrackerForm,
  timeSheetTicketList: timeSheetTicketListInitialState,
  timeSheetTicketListSearchQuery: "",
};
